import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../Components/Back-End/DashboardLayout";
import DashboardHome from "../Pages/Dashboard/Home";
import { EventsTable } from "../Pages/Dashboard/Events";
import { CoachesTable } from "../Pages/Dashboard/Coaches";
import { FAQsTable } from "../Pages/Dashboard/FAQs";
import { BoardMembersTable } from "../Pages/Dashboard/BoardMembers";
import { HomePageCarouselTable } from "../Pages/Dashboard/HomePageCarousel";

const DashboardRoutes = () => {
    return (
        <Routes>
            {/* Layout wrapper */}
            <Route path="/" element={<DashboardLayout />}>
                {/* Nested pages */}
                <Route index element={<DashboardHome />} />         
                <Route path="events" element={<EventsTable />} />     
                <Route path="coaches" element={<CoachesTable />} />  
                <Route path="faqs" element={<FAQsTable />} />  
                <Route path="boardmembers" element={<BoardMembersTable />} />
                <Route path="homepagecarousel" element={<HomePageCarouselTable />} /> 
            </Route>
            {/* Optional catch-all redirect */}
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};

export default DashboardRoutes;
